export default {
  path: '/settings',
  meta: { requiresAuth: true, module: 'settings' },
  children: [
    {
      path: '',
      name: 'SettingsHome',
      component: () => import('../views/settings/Settings.vue'),
      meta: { module: 'settings' }
    },
    {
      path: 'market',
      name: 'MarketSettings',
      component: () => import('../views/settings/market.vue'),
      meta: { module: 'settings' }
    },
    {
      path: 'naver-policy',
      name: 'NaverPolicy',
      component: () => import('../views/settings/NaverPolicy.vue'),
      meta: { module: 'settings' }
    },
    {
      path: 'common-policy',
      name: 'CommonPolicy',
      component: () => import('../views/settings/commonPolicy.vue'),
      meta: { module: 'settings' }
    },
    {
      path: 'process-setting',
      name: 'ProcessSetting',
      component: () => import('../views/settings/processSetting.vue'),
      meta: { module: 'settings' }
    }
  ]
};
